<template>
  <div class="release-actions">
    <EditReleaseButton v-if="release.actions.editDetails" :release="release" />

    <DeactivateReleaseButton
      v-if="shouldShowDeactivateButton"
      class="app-releases-table__button"
      :release-id="release.token"
    />

    <PublishReleaseButton
      v-if="shouldShowPublishButton"
      class="app-releases-table__button"
      :release="release"
    />

    <ResendPublishRequestButton
      v-if="release.actions.resendPublishRequest"
      :release="release"
    />

    <CancelPublishRequest
      v-if="release.actions.cancelReviewRequest"
      :release-id="release.token"
    />
  </div>
</template>

<script>
import PublishReleaseButton from './PublishReleaseButton';
import DeactivateReleaseButton from './DeactivateReleaseButton';
import ResendPublishRequestButton from './ResendPublishRequestButton';
import CancelPublishRequest from './CancelPublishRequest';
import EditReleaseButton from './EditReleaseButton';

export default {
  name: 'ReleaseActions',
  components: {
    PublishReleaseButton,
    DeactivateReleaseButton,
    ResendPublishRequestButton,
    CancelPublishRequest,
    EditReleaseButton,
  },
  props: {
    release: {
      type: Object,
      required: true,
    },
  },

  computed: {
    shouldShowDeactivateButton() {
      const { actions } = this.release;
      return !actions.editDetails && actions.deactivate;
    },
    shouldShowPublishButton() {
      const { actions } = this.release;
      return actions.publish || actions.disabledPublish;
    },
  },
};
</script>

<style lang="scss">
.release-actions {
  display: flex;
  flex-direction: row-reverse;
}
</style>
